const WIDTH = 76, HEIGHT = 44, GAP = 5;
const rounded = value => Math.round(value * 10) / 10;

export function groupSignals(signals = []) {
  const groups = new Map();
  if (!Array.isArray(signals)) return [];
  signals.forEach(signal => {
    if (!Number.isFinite(signal?.time) || !['buy', 'sell'].includes(signal.action) || !['breakout', 'pullback'].includes(signal.setup)) return;
    if (!Number.isFinite(signal.reference_price) || signal.reference_price <= 0) return;
    const key = `${signal.action}-${signal.time}`;
    const group = groups.get(key) || { id: key, time: signal.time, action: signal.action, signals: [] };
    if (!group.signals.some(item => item.id === signal.id)) group.signals.push(signal);
    groups.set(key, group);
  });
  return [...groups.values()].map(group => ({ ...group,
    setup: group.signals.length > 1 ? 'both' : group.signals[0].setup,
    name: group.signals.length > 1 ? 'Both setups' : group.signals[0].setup === 'breakout' ? 'Breakout' : 'Pullback',
    referencePrice: group.signals[0].reference_price,
  }));
}

export function positionSignals(groups, barsByTime, chart, candles, host) {
  const plotWidth = chart.timeScale().width(), plotHeight = host.clientHeight - chart.timeScale().height();
  const candidates = groups.flatMap(group => {
    const bar = barsByTime.get(group.time);
    if (!bar) return [];
    const anchorX = chart.timeScale().timeToCoordinate(group.time);
    const anchorY = candles.priceToCoordinate(group.action === 'buy' ? bar.low : bar.high);
    if (!Number.isFinite(anchorX) || !Number.isFinite(anchorY) || anchorX < 0 || anchorX > plotWidth || anchorY < 0 || anchorY > plotHeight) return [];
    return [{ ...group, anchorX: rounded(anchorX), anchorY: rounded(anchorY) }];
  }).sort((a, b) => b.time - a.time || a.action.localeCompare(b.action));
  const placed = [], compact = [];
  candidates.forEach(group => {
    const left = Math.max(4, Math.min(plotWidth - WIDTH - 4, group.anchorX - WIDTH / 2));
    const below = group.action === 'buy';
    const preferred = below ? group.anchorY + 14 : group.anchorY - HEIGHT - 14;
    let chosen = null;
    for (const offset of [0, HEIGHT + 10, (HEIGHT + 10) * 2]) {
      const top = preferred + (below ? offset : -offset);
      if (top < 4 || top + HEIGHT > plotHeight - 8) continue;
      const overlap = placed.some(other => left < other.left + WIDTH + GAP && left + WIDTH + GAP > other.left
        && top < other.top + HEIGHT + GAP && top + HEIGHT + GAP > other.top);
      if (!overlap) { chosen = top; break; }
    }
    if (chosen == null) compact.push({ ...group, left: Math.max(0, Math.min(plotWidth - 14, group.anchorX - 7)),
      top: Math.max(4, Math.min(plotHeight - 16, below ? group.anchorY + 8 : group.anchorY - 20)) });
    else placed.push({ ...group, left: rounded(left), top: rounded(chosen), width: WIDTH, height: HEIGHT,
      pointerX: rounded(Math.max(9, Math.min(WIDTH - 9, group.anchorX - left))) });
  });
  return { placed, compact, visible: candidates.length };
}